import React, { useRef, useState } from 'react'

import cn from 'classnames'
import Link from 'next/link'

import { COMMUNITY_PATHS } from '@constants/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import I18n from '@utils/i18n';

import CommunityDes from '../communityDes';

import styles from './index.module.less'

const LinkPage = ({ item }) => {
  const { latestPostList } = item
  const [list, setList] = useState(latestPostList)
  const dataRef = useRef(latestPostList)
  const timeRef = useRef();

  // 根据latestPostList而改变list数据，上下是两部分逻辑，不能耦合一起
  useIsomorphicLayoutEffect(() => {
    setList(latestPostList)
    dataRef.current = latestPostList;
  }, [latestPostList])

  useIsomorphicLayoutEffect(() => {
    timeRef.current = setInterval(() => {
      const firstData = dataRef.current.shift()
      dataRef.current = [...dataRef.current, firstData]
      setList(dataRef.current)
    }, 5000)
    return () => {
      clearInterval(timeRef.current);
    }
  }, [])

  return <Link legacyBehavior href={COMMUNITY_PATHS.TOPIC + item.id} key={item.authorId}>
            <div
                className={cn(styles.hotlistItem
                )}>
                    <div className={styles.hotCommunityList}>
                        <div className={styles.hotTitleList}>
                            <div
                            className={styles.hotTopic}
                            style={{ backgroundColor: item?.pollViewId ? '#6F40EE' : '#FF6100' }}
                            >
                                {
                                    item?.pollViewId ? I18n.t('community_poll') : I18n.t('community_hot_topic')
                                }
                            </div>
                            <div className={cn(styles.hotTitle, 'DINPro-Bold')}>
                                {item.content}
                            </div>
                        </div>
                        <div className={styles.hotContBottom}>
                            <div className={styles.customerMisc}>
                                {/* 推荐热门话题滚动内容 */}
                                {
                                  // latestPostList.length > 0
                                  //   ? (
                                        list?.map((data, num) => (
                                          <div className={cn(styles.communityWrapper, { [styles.textData]: !num })} key={`${data?.timestamp}_${num}`}>
                                              <CommunityDes data={data}/>
                                          </div>
                                        ))
                                    //   )
                                    // : ''
                                }
                            </div>
                        </div>
                    </div>
            </div>
          </Link>
}
export default LinkPage
